export const LayoutPaddingBox = 5;
